import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "stats-config-editor bg-white flex flex-col"
};
const _hoisted_2 = {
  class: "editor-tip"
};
const _hoisted_3 = {
  class: "p-6 space-y-6 max-h-[520px] overflow-y-auto"
};
const _hoisted_4 = {
  class: "flex items-center gap-2 mb-2"
};
const _hoisted_5 = ["disabled"];
const _hoisted_6 = {
  key: 0,
  class: "text-xs text-slate-400 border border-dashed border-slate-200 rounded-lg px-3 py-4 text-center"
};
const _hoisted_7 = {
  key: 1,
  class: "space-y-1.5"
};
const _hoisted_8 = ["title"];
const _hoisted_9 = {
  class: "text-xs text-slate-400 w-10 shrink-0"
};
const _hoisted_10 = ["title"];
const _hoisted_11 = ["onUpdate:modelValue"];
const _hoisted_12 = {
  class: "flex items-center gap-1 shrink-0"
};
const _hoisted_13 = ["disabled", "onClick"];
const _hoisted_14 = ["disabled", "onClick"];
const _hoisted_15 = ["onClick"];
const _hoisted_16 = {
  class: "mb-2"
};
const _hoisted_17 = {
  class: "text-sm font-semibold text-slate-700"
};
const _hoisted_18 = {
  class: "flex items-center gap-2 mb-2"
};
const _hoisted_19 = ["disabled"];
const _hoisted_20 = {
  key: 0,
  class: "text-xs text-slate-400 border border-dashed border-slate-200 rounded-lg px-3 py-4 text-center"
};
const _hoisted_21 = {
  key: 1,
  class: "space-y-1.5"
};
const _hoisted_22 = ["title"];
const _hoisted_23 = {
  class: "text-xs text-slate-400 w-10 shrink-0"
};
const _hoisted_24 = ["title"];
const _hoisted_25 = ["onUpdate:modelValue"];
const _hoisted_26 = {
  class: "flex items-center gap-1 shrink-0"
};
const _hoisted_27 = ["disabled", "onClick"];
const _hoisted_28 = ["disabled", "onClick"];
const _hoisted_29 = ["onClick"];
const _hoisted_30 = {
  class: "space-y-1.5 mb-2"
};
const _hoisted_31 = ["title"];
const _hoisted_32 = ["onUpdate:modelValue"];
const _hoisted_33 = ["onClick"];
const _hoisted_34 = {
  key: 0,
  class: "text-xs text-slate-400 border border-dashed border-slate-200 rounded-lg px-3 py-4 text-center"
};
const _hoisted_35 = {
  class: "border-t border-slate-100 pt-6"
};
const _hoisted_36 = {
  class: "max-w-md mb-4"
};
const _hoisted_37 = {
  class: "mb-6"
};
const _hoisted_38 = {
  class: "flex items-center gap-2 mb-2"
};
const _hoisted_39 = ["disabled"];
const _hoisted_40 = {
  key: 0,
  class: "text-xs text-slate-400 border border-dashed border-slate-200 rounded-lg px-3 py-4 text-center"
};
const _hoisted_41 = {
  key: 1,
  class: "space-y-1.5"
};
const _hoisted_42 = ["title"];
const _hoisted_43 = {
  class: "text-xs text-slate-400 w-10 shrink-0"
};
const _hoisted_44 = ["title"];
const _hoisted_45 = ["onUpdate:modelValue"];
const _hoisted_46 = {
  class: "flex items-center gap-1 shrink-0"
};
const _hoisted_47 = ["disabled", "onClick"];
const _hoisted_48 = ["disabled", "onClick"];
const _hoisted_49 = ["onClick"];
const _hoisted_50 = {
  class: "mb-6"
};
const _hoisted_51 = {
  class: "mb-2"
};
const _hoisted_52 = {
  class: "text-sm font-semibold text-slate-700"
};
const _hoisted_53 = {
  class: "flex items-center gap-2 mb-2"
};
const _hoisted_54 = ["disabled"];
const _hoisted_55 = {
  key: 0,
  class: "text-xs text-slate-400 border border-dashed border-slate-200 rounded-lg px-3 py-4 text-center"
};
const _hoisted_56 = {
  key: 1,
  class: "space-y-1.5"
};
const _hoisted_57 = ["title"];
const _hoisted_58 = {
  class: "text-xs text-slate-400 w-10 shrink-0"
};
const _hoisted_59 = ["title"];
const _hoisted_60 = ["onUpdate:modelValue"];
const _hoisted_61 = {
  class: "flex items-center gap-1 shrink-0"
};
const _hoisted_62 = ["disabled", "onClick"];
const _hoisted_63 = ["disabled", "onClick"];
const _hoisted_64 = ["onClick"];
const _hoisted_65 = {
  class: "space-y-1.5 mb-2"
};
const _hoisted_66 = ["title"];
const _hoisted_67 = ["onUpdate:modelValue"];
const _hoisted_68 = ["onClick"];
const _hoisted_69 = {
  key: 0,
  class: "text-xs text-slate-400 border border-dashed border-slate-200 rounded-lg px-3 py-4 text-center"
};
const _hoisted_70 = {
  key: 0,
  class: "text-xs text-amber-600"
};
import { ref, computed, watch } from 'vue';
import { ArrowUp, ArrowDown, Delete, WarningFilled, InfoFilled } from '@element-plus/icons-vue';
import { STATS_CONFIG_VERSION, STATS_LIST_SYSTEM_COLUMNS, STATS_SUMMARY_SYSTEM_DIMENSIONS, STATS_DIMENSION_FIELD_TYPES, STATS_DETAIL_DIMENSION_FIELD_TYPES, STATS_NUMERIC_FIELD_TYPES, STATS_DIMENSION_MIN, STATS_DIMENSION_MAX, STATS_COUNT_KEY, collectStatsNumericKeys, collectDetailChildren, collectInvalidStatsKeys } from '@/utils/workflowStatsConfig';
export default {
  __name: 'StatsConfigEditor',
  props: {
    // 模板当前表单字段（FormDesigner getFieldList 结构：key/label/type/summary），实时同步
    fields: {
      type: Array,
      default: () => []
    },
    // 已有统计配置（加载模板回填），null 表示未配置
    initialConfig: {
      type: Object,
      default: null
    }
  },
  setup(__props, {
    expose: __expose
  }) {
    const props = __props;
    const columns = ref([]);
    const dimensions = ref([]);
    const metrics = ref([]);
    const pendingColumnKey = ref('');
    const pendingDimensionKey = ref('');
    // 明细行统计（可选）：detailKey 为空 = 不启用行级统计
    const detailKey = ref('');
    const detailColumns = ref([]);
    const detailDimensions = ref([]);
    const detailMetrics = ref([]);
    const pendingDetailColumnKey = ref('');
    const pendingDetailDimensionKey = ref('');

    // 新开启"统计导出"时的默认方案：4 个系统清单列 + 部门维度 + 单据数指标
    function defaultPlan() {
      return {
        columns: STATS_LIST_SYSTEM_COLUMNS.filter(c => c.key !== 'status').map(c => ({
          type: 'SYSTEM',
          key: c.key,
          label: c.label
        })),
        dimensions: [{
          type: 'SYSTEM',
          key: 'deptName',
          label: '部门'
        }],
        metrics: [{
          key: STATS_COUNT_KEY,
          aggregate: 'COUNT',
          label: '单据数'
        }]
      };
    }
    function initConfig(config) {
      const plan = Array.isArray(config?.stats) && config.stats.length > 0 ? config.stats[0] : null;
      const source = plan ? {
        columns: (plan.listSheet?.columns || []).map(c => ({
          ...c
        })),
        dimensions: (plan.summarySheet?.dimensions || []).map(d => ({
          ...d
        })),
        metrics: (plan.summarySheet?.metrics || []).map(m => ({
          ...m
        }))
      } : defaultPlan();
      columns.value = source.columns;
      dimensions.value = source.dimensions;
      metrics.value = source.metrics;
      pendingColumnKey.value = '';
      pendingDimensionKey.value = '';
      // 明细行统计回填（detailSheet 可选，缺省 = 不启用）
      const detailSheet = plan?.detailSheet;
      detailKey.value = detailSheet?.detailKey || '';
      detailColumns.value = (detailSheet?.columns || []).map(c => ({
        ...c
      }));
      detailDimensions.value = (detailSheet?.dimensions || []).map(d => ({
        ...d
      }));
      detailMetrics.value = (detailSheet?.metrics || []).map(m => ({
        ...m
      }));
      pendingDetailColumnKey.value = '';
      pendingDetailDimensionKey.value = '';
    }

    // 加载模板回填（与 ExportLayoutDesigner watch initialLayout 同款模式）
    watch(() => props.initialConfig, config => {
      initConfig(config);
    }, {
      immediate: true
    });

    // ---- 候选项 ----
    // 清单 FIELD 列候选：顶层非 DETAIL 字段 + summary.targetKey 虚拟字段（spec §4，排除 DETAIL 容器）
    const fieldColumnCandidates = computed(() => {
      const items = [];
      (props.fields || []).forEach(field => {
        if (!field) return;
        if (String(field.type ?? '').toUpperCase() === 'DETAIL') {
          (field.summary || []).forEach(sum => {
            if (sum?.targetKey) {
              items.push({
                key: sum.targetKey,
                label: `${field.label}·${sum.label || sum.targetKey}`
              });
            }
          });
          return;
        }
        if (field.key) items.push({
          key: field.key,
          label: field.label
        });
      });
      return items;
    });
    const availableSystemColumns = computed(() => STATS_LIST_SYSTEM_COLUMNS.map(c => ({
      ...c,
      added: columns.value.some(col => col.type === 'SYSTEM' && col.key === c.key)
    })));
    const availableFieldColumns = computed(() => fieldColumnCandidates.value.map(c => ({
      ...c,
      added: columns.value.some(col => col.type === 'FIELD' && col.key === c.key)
    })));

    // 汇总维度 FIELD 候选：类型白名单 SELECT/RADIO/SWITCH/DATE/DATETIME（spec §4）
    const dimensionFieldCandidates = computed(() => (props.fields || []).filter(field => field?.key && STATS_DIMENSION_FIELD_TYPES.includes(String(field.type ?? '').toUpperCase())).map(field => ({
      key: field.key,
      label: field.label
    })));
    const availableSystemDimensions = computed(() => STATS_SUMMARY_SYSTEM_DIMENSIONS.map(d => ({
      ...d,
      added: dimensions.value.some(dim => dim.type === 'SYSTEM' && dim.key === d.key)
    })));
    const availableFieldDimensions = computed(() => dimensionFieldCandidates.value.map(d => ({
      ...d,
      added: dimensions.value.some(dim => dim.type === 'FIELD' && dim.key === d.key)
    })));

    // 指标统计列候选：数值字段/明细合计值 + 单据数（COUNT 固定 key="*"）
    const metricKeyCandidates = computed(() => {
      const numericKeys = collectStatsNumericKeys(props.fields);
      const items = fieldColumnCandidates.value.filter(c => numericKeys.has(c.key));
      items.push({
        key: STATS_COUNT_KEY,
        label: '单据数'
      });
      return items;
    });

    // ---- 明细行统计候选项（2026-09-21 spec §4.2：子字段候选按所选 detailKey 的 children 联动） ----
    // DETAIL 选择器候选 = 顶层 DETAIL 字段
    const detailFieldCandidates = computed(() => (props.fields || []).filter(field => field?.key && String(field.type ?? '').toUpperCase() === 'DETAIL').map(field => ({
      key: field.key,
      label: field.label
    })));

    // 所选明细表的子字段数组（detailKey 失效时为空数组）
    const detailChildren = computed(() => collectDetailChildren(props.fields, detailKey.value));

    // 明细清单子字段列候选：全部子字段（全部子类型允许，spec §4.2 规则 2）
    const detailChildColumnCandidates = computed(() => detailChildren.value.filter(child => child?.key).map(child => ({
      key: child.key,
      label: child.label
    })));

    // 明细汇总子字段维度候选：类型白名单 SELECT/RADIO/DATE/DATETIME（子字段类型域无 SWITCH，spec §4.2 规则 3）
    const detailChildDimensionCandidates = computed(() => detailChildren.value.filter(child => child?.key && STATS_DETAIL_DIMENSION_FIELD_TYPES.includes(String(child.type ?? '').toUpperCase())).map(child => ({
      key: child.key,
      label: child.label
    })));

    // 明细汇总指标统计列候选：数值/金额子字段 + 明细行数（COUNT 固定 key="*"，= 明细行数）
    const detailMetricKeyCandidates = computed(() => {
      const items = detailChildren.value.filter(child => child?.key && STATS_NUMERIC_FIELD_TYPES.includes(String(child.type ?? '').toUpperCase())).map(child => ({
        key: child.key,
        label: child.label
      }));
      items.push({
        key: STATS_COUNT_KEY,
        label: '明细行数'
      });
      return items;
    });
    const availableDetailSystemColumns = computed(() => STATS_LIST_SYSTEM_COLUMNS.map(c => ({
      ...c,
      added: detailColumns.value.some(col => col.type === 'SYSTEM' && col.key === c.key)
    })));
    const availableDetailFieldColumns = computed(() => detailChildColumnCandidates.value.map(c => ({
      ...c,
      added: detailColumns.value.some(col => col.type === 'FIELD' && col.key === c.key)
    })));
    const availableDetailSystemDimensions = computed(() => STATS_SUMMARY_SYSTEM_DIMENSIONS.map(d => ({
      ...d,
      added: detailDimensions.value.some(dim => dim.type === 'SYSTEM' && dim.key === d.key)
    })));
    const availableDetailFieldDimensions = computed(() => detailChildDimensionCandidates.value.map(d => ({
      ...d,
      added: detailDimensions.value.some(dim => dim.type === 'FIELD' && dim.key === d.key)
    })));

    // ---- 标黄：formSchema 变更后失效引用（spec §4 联动标黄，与单据导出设计器同款交互） ----
    const currentConfig = computed(() => ({
      version: STATS_CONFIG_VERSION,
      stats: [{
        listSheet: {
          columns: columns.value
        },
        summarySheet: {
          dimensions: dimensions.value,
          metrics: metrics.value
        },
        detailSheet: detailKey.value ? {
          detailKey: detailKey.value,
          columns: detailColumns.value,
          dimensions: detailDimensions.value,
          metrics: detailMetrics.value
        } : null
      }]
    }));
    const invalidKeys = computed(() => collectInvalidStatsKeys(currentConfig.value, props.fields));
    const hasInvalidKeys = computed(() => invalidKeys.value.columnKeys.size > 0 || invalidKeys.value.dimensionKeys.size > 0 || invalidKeys.value.metricKeys.size > 0 || invalidKeys.value.detail.columnKeys.size > 0 || invalidKeys.value.detail.dimensionKeys.size > 0 || invalidKeys.value.detail.metricKeys.size > 0);
    function isColumnInvalid(col) {
      return col.type === 'FIELD' && invalidKeys.value.columnKeys.has(col.key);
    }
    function isDimensionInvalid(dim) {
      return dim.type === 'FIELD' && invalidKeys.value.dimensionKeys.has(dim.key);
    }
    function isMetricInvalid(metric) {
      return metric.key !== STATS_COUNT_KEY && invalidKeys.value.metricKeys.has(metric.key);
    }

    // 行级作用域标黄：detailSheet 内引用查 detail.* 三个 Set，与顶层同名 key 不互标黄（spec §4.2 前端契约）
    function isDetailColumnInvalid(col) {
      return col.type === 'FIELD' && invalidKeys.value.detail.columnKeys.has(col.key);
    }
    function isDetailDimensionInvalid(dim) {
      return dim.type === 'FIELD' && invalidKeys.value.detail.dimensionKeys.has(dim.key);
    }
    function isDetailMetricInvalid(metric) {
      return metric.key !== STATS_COUNT_KEY && invalidKeys.value.detail.metricKeys.has(metric.key);
    }

    // type:key → 来源字段名（候选列表 label；失效 key 回退显示原始 key）
    const columnLabelMap = computed(() => {
      const map = {};
      fieldColumnCandidates.value.forEach(c => {
        map[`FIELD:${c.key}`] = c.label;
      });
      STATS_LIST_SYSTEM_COLUMNS.forEach(c => {
        map[`SYSTEM:${c.key}`] = c.label;
      });
      return map;
    });
    const dimensionLabelMap = computed(() => {
      const map = {};
      dimensionFieldCandidates.value.forEach(c => {
        map[`FIELD:${c.key}`] = c.label;
      });
      STATS_SUMMARY_SYSTEM_DIMENSIONS.forEach(c => {
        map[`SYSTEM:${c.key}`] = c.label;
      });
      return map;
    });
    function sourceColumnLabel(col) {
      return columnLabelMap.value[`${col.type}:${col.key}`] || col.key;
    }
    function sourceDimensionLabel(dim) {
      return dimensionLabelMap.value[`${dim.type}:${dim.key}`] || dim.key;
    }

    // 行级来源名（候选列表 label；失效 key 回退显示原始 key）
    const detailColumnLabelMap = computed(() => {
      const map = {};
      detailChildColumnCandidates.value.forEach(c => {
        map[`FIELD:${c.key}`] = c.label;
      });
      STATS_LIST_SYSTEM_COLUMNS.forEach(c => {
        map[`SYSTEM:${c.key}`] = c.label;
      });
      return map;
    });
    const detailDimensionLabelMap = computed(() => {
      const map = {};
      detailChildDimensionCandidates.value.forEach(c => {
        map[`FIELD:${c.key}`] = c.label;
      });
      STATS_SUMMARY_SYSTEM_DIMENSIONS.forEach(c => {
        map[`SYSTEM:${c.key}`] = c.label;
      });
      return map;
    });
    function sourceDetailColumnLabel(col) {
      return detailColumnLabelMap.value[`${col.type}:${col.key}`] || col.key;
    }
    function sourceDetailDimensionLabel(dim) {
      return detailDimensionLabelMap.value[`${dim.type}:${dim.key}`] || dim.key;
    }
    function aggregateLabel(aggregate) {
      const labels = {
        SUM: '求和',
        AVG: '平均',
        MAX: '最大',
        MIN: '最小',
        COUNT: '计数'
      };
      return labels[aggregate] || aggregate;
    }

    // 解析 "TYPE:key" 候选值（字段 key 本身不含冒号）
    function parsePendingKey(raw) {
      const sep = String(raw || '').indexOf(':');
      if (sep < 0) return null;
      return {
        type: raw.slice(0, sep),
        key: raw.slice(sep + 1)
      };
    }

    // ---- 清单列操作 ----
    function addColumn() {
      const parsed = parsePendingKey(pendingColumnKey.value);
      if (!parsed) return;
      const label = columnLabelMap.value[pendingColumnKey.value] || parsed.key;
      columns.value.push({
        type: parsed.type,
        key: parsed.key,
        label
      });
      pendingColumnKey.value = '';
    }
    function moveColumn(index, offset) {
      const target = index + offset;
      if (target < 0 || target >= columns.value.length) return;
      const [item] = columns.value.splice(index, 1);
      columns.value.splice(target, 0, item);
    }
    function removeColumn(index) {
      columns.value.splice(index, 1);
    }

    // ---- 汇总维度操作 ----
    function addDimension() {
      if (dimensions.value.length >= STATS_DIMENSION_MAX) return;
      const parsed = parsePendingKey(pendingDimensionKey.value);
      if (!parsed) return;
      const label = dimensionLabelMap.value[pendingDimensionKey.value] || parsed.key;
      dimensions.value.push({
        type: parsed.type,
        key: parsed.key,
        label
      });
      pendingDimensionKey.value = '';
    }
    function moveDimension(index, offset) {
      const target = index + offset;
      if (target < 0 || target >= dimensions.value.length) return;
      const [item] = dimensions.value.splice(index, 1);
      dimensions.value.splice(target, 0, item);
    }
    function removeDimension(index) {
      dimensions.value.splice(index, 1);
    }

    // ---- 汇总指标操作 ----
    function addMetric() {
      metrics.value.push({
        key: STATS_COUNT_KEY,
        aggregate: 'COUNT',
        label: '单据数'
      });
    }

    // 统计列变更联动：单据数锁定 COUNT；切回数值列时 COUNT 复位为 SUM；label 默认跟随列名
    function onMetricKeyChange(metric) {
      if (metric.key === STATS_COUNT_KEY) {
        metric.aggregate = 'COUNT';
      } else if (metric.aggregate === 'COUNT') {
        metric.aggregate = 'SUM';
      }
      const candidate = metricKeyCandidates.value.find(c => c.key === metric.key);
      if (candidate) metric.label = candidate.label;
    }
    function removeMetric(index) {
      metrics.value.splice(index, 1);
    }

    // ---- 明细行统计操作 ----
    // 切换/清空 DETAIL 时清空已选行级配置（加载回填走 initConfig 直接赋值，不经过此处理）
    function handleDetailKeyChange() {
      detailColumns.value = [];
      detailDimensions.value = [];
      detailMetrics.value = [];
      pendingDetailColumnKey.value = '';
      pendingDetailDimensionKey.value = '';
    }
    function addDetailColumn() {
      const parsed = parsePendingKey(pendingDetailColumnKey.value);
      if (!parsed) return;
      const label = detailColumnLabelMap.value[pendingDetailColumnKey.value] || parsed.key;
      detailColumns.value.push({
        type: parsed.type,
        key: parsed.key,
        label
      });
      pendingDetailColumnKey.value = '';
    }
    function moveDetailColumn(index, offset) {
      const target = index + offset;
      if (target < 0 || target >= detailColumns.value.length) return;
      const [item] = detailColumns.value.splice(index, 1);
      detailColumns.value.splice(target, 0, item);
    }
    function removeDetailColumn(index) {
      detailColumns.value.splice(index, 1);
    }
    function addDetailDimension() {
      if (detailDimensions.value.length >= STATS_DIMENSION_MAX) return;
      const parsed = parsePendingKey(pendingDetailDimensionKey.value);
      if (!parsed) return;
      const label = detailDimensionLabelMap.value[pendingDetailDimensionKey.value] || parsed.key;
      detailDimensions.value.push({
        type: parsed.type,
        key: parsed.key,
        label
      });
      pendingDetailDimensionKey.value = '';
    }
    function moveDetailDimension(index, offset) {
      const target = index + offset;
      if (target < 0 || target >= detailDimensions.value.length) return;
      const [item] = detailDimensions.value.splice(index, 1);
      detailDimensions.value.splice(target, 0, item);
    }
    function removeDetailDimension(index) {
      detailDimensions.value.splice(index, 1);
    }
    function addDetailMetric() {
      detailMetrics.value.push({
        key: STATS_COUNT_KEY,
        aggregate: 'COUNT',
        label: '明细行数'
      });
    }

    // 统计列变更联动：明细行数锁定 COUNT；切回数值子字段时 COUNT 复位为 SUM；label 默认跟随列名
    function onDetailMetricKeyChange(metric) {
      if (metric.key === STATS_COUNT_KEY) {
        metric.aggregate = 'COUNT';
      } else if (metric.aggregate === 'COUNT') {
        metric.aggregate = 'SUM';
      }
      const candidate = detailMetricKeyCandidates.value.find(c => c.key === metric.key);
      if (candidate) metric.label = candidate.label;
    }
    function removeDetailMetric(index) {
      detailMetrics.value.splice(index, 1);
    }

    // 供 WorkflowDesigner 保存时调用（spec §4：单方案输出，模型为方案数组；detailSheet 未配置时输出 null，保持三态语义）
    function getStatsConfig() {
      return {
        version: STATS_CONFIG_VERSION,
        stats: [{
          listSheet: {
            columns: columns.value.map(c => ({
              type: c.type,
              key: c.key,
              label: c.label
            }))
          },
          summarySheet: {
            dimensions: dimensions.value.map(d => ({
              type: d.type,
              key: d.key,
              label: d.label
            })),
            metrics: metrics.value.map(m => ({
              key: m.key,
              aggregate: m.aggregate,
              label: m.label
            }))
          },
          detailSheet: detailKey.value ? {
            detailKey: detailKey.value,
            columns: detailColumns.value.map(c => ({
              type: c.type,
              key: c.key,
              label: c.label
            })),
            dimensions: detailDimensions.value.map(d => ({
              type: d.type,
              key: d.key,
              label: d.label
            })),
            metrics: detailMetrics.value.map(m => ({
              key: m.key,
              aggregate: m.aggregate,
              label: m.label
            }))
          } : null
        }]
      };
    }
    __expose({
      getStatsConfig
    });
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_option_group = _resolveComponent("el-option-group");
      const _component_el_select = _resolveComponent("el-select");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_icon, {
        size: 14,
        class: "text-primary-600 shrink-0 mt-0.5"
      }, {
        default: _withCtx(() => [_createVNode(_unref(InfoFilled))]),
        _: 1
      }), _cache[5] || (_cache[5] = _createElementVNode("span", {
        class: "text-xs text-slate-600 leading-relaxed"
      }, " 审批中心与流程列表可按时间区间导出\"清单 + 汇总\"双 sheet 统计表；可选追加明细行级 sheet。引用的字段被删除或类型不再满足要求时会标黄警示，保存时将被拦截。 ", -1))]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", null, [_cache[6] || (_cache[6] = _createElementVNode("div", {
        class: "mb-2"
      }, [_createElementVNode("h4", {
        class: "text-sm font-semibold text-slate-700"
      }, "清单列（一实例一行）"), _createElementVNode("p", {
        class: "text-xs text-slate-400 mt-0.5"
      }, "至少 1 列，顺序即导出列顺序；明细表字段不可作为清单列（可选其合计值字段）")], -1)), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_select, {
        modelValue: pendingColumnKey.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => pendingColumnKey.value = $event),
        placeholder: "选择要添加的列",
        class: "form-select w-80",
        filterable: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_option_group, {
          label: "系统字段"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableSystemColumns.value, item => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: 'sys-' + item.key,
              label: item.label,
              value: 'SYSTEM:' + item.key,
              disabled: item.added
            }, null, 8, ["label", "value", "disabled"]);
          }), 128))]),
          _: 1
        }), _createVNode(_component_el_option_group, {
          label: "表单字段"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableFieldColumns.value, item => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: 'field-' + item.key,
              label: item.label,
              value: 'FIELD:' + item.key,
              disabled: item.added
            }, null, 8, ["label", "value", "disabled"]);
          }), 128))]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"]), _createElementVNode("button", {
        type: "button",
        class: "btn-outline-primary",
        disabled: !pendingColumnKey.value,
        onClick: addColumn
      }, "添加列", 8, _hoisted_5)]), columns.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_6, " 暂未配置清单列 ")) : (_openBlock(), _createElementBlock("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(columns.value, (col, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: col.type + ':' + col.key,
          class: _normalizeClass(["flex items-center gap-2 px-3 py-2 border rounded-lg", isColumnInvalid(col) ? 'bg-amber-50 border-amber-300' : 'bg-white border-slate-200']),
          title: isColumnInvalid(col) ? '引用的字段已删除，保存时将被拦截' : ''
        }, [isColumnInvalid(col) ? (_openBlock(), _createBlock(_component_el_icon, {
          key: 0,
          size: 12,
          class: "text-amber-500 shrink-0"
        }, {
          default: _withCtx(() => [_createVNode(_unref(WarningFilled))]),
          _: 1
        })) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_9, _toDisplayString(col.type === 'SYSTEM' ? '系统' : '字段'), 1), _createElementVNode("span", {
          class: "text-sm text-slate-600 w-44 truncate shrink-0",
          title: col.key
        }, _toDisplayString(sourceColumnLabel(col)), 9, _hoisted_10), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": $event => col.label = $event,
          class: "form-input form-control-sm flex-1",
          placeholder: "列名（默认取字段名）"
        }, null, 8, _hoisted_11), [[_vModelText, col.label]]), _createElementVNode("div", _hoisted_12, [_createElementVNode("button", {
          type: "button",
          class: "w-6 h-6 flex items-center justify-center rounded bg-white border border-slate-300 hover:bg-slate-50 disabled:opacity-40",
          disabled: index === 0,
          onClick: $event => moveColumn(index, -1)
        }, [_createVNode(_component_el_icon, {
          size: 10
        }, {
          default: _withCtx(() => [_createVNode(_unref(ArrowUp))]),
          _: 1
        })], 8, _hoisted_13), _createElementVNode("button", {
          type: "button",
          class: "w-6 h-6 flex items-center justify-center rounded bg-white border border-slate-300 hover:bg-slate-50 disabled:opacity-40",
          disabled: index === columns.value.length - 1,
          onClick: $event => moveColumn(index, 1)
        }, [_createVNode(_component_el_icon, {
          size: 10
        }, {
          default: _withCtx(() => [_createVNode(_unref(ArrowDown))]),
          _: 1
        })], 8, _hoisted_14), _createElementVNode("button", {
          type: "button",
          class: "w-6 h-6 flex items-center justify-center rounded bg-white border border-slate-300 hover:bg-red-50 hover:text-red-600",
          onClick: $event => removeColumn(index)
        }, [_createVNode(_component_el_icon, {
          size: 10
        }, {
          default: _withCtx(() => [_createVNode(_unref(Delete))]),
          _: 1
        })], 8, _hoisted_15)])], 10, _hoisted_8);
      }), 128))]))]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_16, [_createElementVNode("h4", _hoisted_17, "汇总维度（" + _toDisplayString(_unref(STATS_DIMENSION_MIN)) + "-" + _toDisplayString(_unref(STATS_DIMENSION_MAX)) + " 个，顺序即分组层级）", 1), _cache[7] || (_cache[7] = _createElementVNode("p", {
        class: "text-xs text-slate-400 mt-0.5"
      }, "表单字段维度仅支持下拉/单选/开关/日期类型；空值归入\"（空白）\"组", -1))]), _createElementVNode("div", _hoisted_18, [_createVNode(_component_el_select, {
        modelValue: pendingDimensionKey.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => pendingDimensionKey.value = $event),
        placeholder: "选择要添加的维度",
        class: "form-select w-80",
        filterable: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_option_group, {
          label: "系统维度"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableSystemDimensions.value, item => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: 'sys-' + item.key,
              label: item.label,
              value: 'SYSTEM:' + item.key,
              disabled: item.added
            }, null, 8, ["label", "value", "disabled"]);
          }), 128))]),
          _: 1
        }), _createVNode(_component_el_option_group, {
          label: "表单字段"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableFieldDimensions.value, item => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: 'field-' + item.key,
              label: item.label,
              value: 'FIELD:' + item.key,
              disabled: item.added
            }, null, 8, ["label", "value", "disabled"]);
          }), 128))]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"]), _createElementVNode("button", {
        type: "button",
        class: "btn-outline-primary",
        disabled: !pendingDimensionKey.value || dimensions.value.length >= _unref(STATS_DIMENSION_MAX),
        onClick: addDimension
      }, "添加维度", 8, _hoisted_19)]), dimensions.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_20, " 暂未配置汇总维度 ")) : (_openBlock(), _createElementBlock("div", _hoisted_21, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dimensions.value, (dim, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: dim.type + ':' + dim.key,
          class: _normalizeClass(["flex items-center gap-2 px-3 py-2 border rounded-lg", isDimensionInvalid(dim) ? 'bg-amber-50 border-amber-300' : 'bg-white border-slate-200']),
          title: isDimensionInvalid(dim) ? '引用的字段已删除或类型不再满足白名单，保存时将被拦截' : ''
        }, [isDimensionInvalid(dim) ? (_openBlock(), _createBlock(_component_el_icon, {
          key: 0,
          size: 12,
          class: "text-amber-500 shrink-0"
        }, {
          default: _withCtx(() => [_createVNode(_unref(WarningFilled))]),
          _: 1
        })) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_23, "第 " + _toDisplayString(index + 1) + " 层", 1), _createElementVNode("span", {
          class: "text-sm text-slate-600 w-44 truncate shrink-0",
          title: dim.key
        }, _toDisplayString(sourceDimensionLabel(dim)), 9, _hoisted_24), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": $event => dim.label = $event,
          class: "form-input form-control-sm flex-1",
          placeholder: "维度名（默认取字段名）"
        }, null, 8, _hoisted_25), [[_vModelText, dim.label]]), _createElementVNode("div", _hoisted_26, [_createElementVNode("button", {
          type: "button",
          class: "w-6 h-6 flex items-center justify-center rounded bg-white border border-slate-300 hover:bg-slate-50 disabled:opacity-40",
          disabled: index === 0,
          onClick: $event => moveDimension(index, -1)
        }, [_createVNode(_component_el_icon, {
          size: 10
        }, {
          default: _withCtx(() => [_createVNode(_unref(ArrowUp))]),
          _: 1
        })], 8, _hoisted_27), _createElementVNode("button", {
          type: "button",
          class: "w-6 h-6 flex items-center justify-center rounded bg-white border border-slate-300 hover:bg-slate-50 disabled:opacity-40",
          disabled: index === dimensions.value.length - 1,
          onClick: $event => moveDimension(index, 1)
        }, [_createVNode(_component_el_icon, {
          size: 10
        }, {
          default: _withCtx(() => [_createVNode(_unref(ArrowDown))]),
          _: 1
        })], 8, _hoisted_28), _createElementVNode("button", {
          type: "button",
          class: "w-6 h-6 flex items-center justify-center rounded bg-white border border-slate-300 hover:bg-red-50 hover:text-red-600",
          onClick: $event => removeDimension(index)
        }, [_createVNode(_component_el_icon, {
          size: 10
        }, {
          default: _withCtx(() => [_createVNode(_unref(Delete))]),
          _: 1
        })], 8, _hoisted_29)])], 10, _hoisted_22);
      }), 128))]))]), _createElementVNode("div", null, [_cache[8] || (_cache[8] = _createElementVNode("div", {
        class: "mb-2"
      }, [_createElementVNode("h4", {
        class: "text-sm font-semibold text-slate-700"
      }, "汇总指标"), _createElementVNode("p", {
        class: "text-xs text-slate-400 mt-0.5"
      }, "至少 1 个；求和/平均/最大/最小限数值字段或明细合计值，计数固定统计单据数")], -1)), _createElementVNode("div", _hoisted_30, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(metrics.value, (metric, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(["flex items-center gap-2 px-3 py-2 border rounded-lg", isMetricInvalid(metric) ? 'bg-amber-50 border-amber-300' : 'bg-white border-slate-200']),
          title: isMetricInvalid(metric) ? '引用的字段已删除或不再是数值字段，保存时将被拦截' : ''
        }, [isMetricInvalid(metric) ? (_openBlock(), _createBlock(_component_el_icon, {
          key: 0,
          size: 12,
          class: "text-amber-500 shrink-0"
        }, {
          default: _withCtx(() => [_createVNode(_unref(WarningFilled))]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_component_el_select, {
          modelValue: metric.key,
          "onUpdate:modelValue": $event => metric.key = $event,
          class: "form-select w-52",
          placeholder: "统计列",
          onChange: $event => onMetricKeyChange(metric)
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(metricKeyCandidates.value, item => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: item.key,
              label: item.label,
              value: item.key
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue", "onUpdate:modelValue", "onChange"]), _createVNode(_component_el_select, {
          modelValue: metric.aggregate,
          "onUpdate:modelValue": $event => metric.aggregate = $event,
          class: "form-select w-32",
          disabled: metric.key === _unref(STATS_COUNT_KEY)
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(metric.key === _unref(STATS_COUNT_KEY) ? ['COUNT'] : ['SUM', 'AVG', 'MAX', 'MIN'], agg => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: agg,
              label: aggregateLabel(agg),
              value: agg
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 2
        }, 1032, ["modelValue", "onUpdate:modelValue", "disabled"]), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": $event => metric.label = $event,
          class: "form-input form-control-sm flex-1",
          placeholder: "指标名（默认取列名）"
        }, null, 8, _hoisted_32), [[_vModelText, metric.label]]), _createElementVNode("button", {
          type: "button",
          class: "w-6 h-6 flex items-center justify-center rounded bg-white border border-slate-300 hover:bg-red-50 hover:text-red-600 shrink-0",
          onClick: $event => removeMetric(index)
        }, [_createVNode(_component_el_icon, {
          size: 10
        }, {
          default: _withCtx(() => [_createVNode(_unref(Delete))]),
          _: 1
        })], 8, _hoisted_33)], 10, _hoisted_31);
      }), 128)), metrics.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_34, " 暂未配置汇总指标 ")) : _createCommentVNode("", true)]), _createElementVNode("button", {
        type: "button",
        class: "btn-outline-primary",
        onClick: addMetric
      }, "添加指标")]), _createElementVNode("div", _hoisted_35, [_cache[13] || (_cache[13] = _createElementVNode("div", {
        class: "mb-2"
      }, [_createElementVNode("h4", {
        class: "text-sm font-semibold text-slate-700"
      }, "明细行统计（可选）"), _createElementVNode("p", {
        class: "text-xs text-slate-400 mt-0.5"
      }, "选择一个明细表后，按行内子字段追加\"明细清单 + 明细汇总\"两个 sheet（一行 = 一条明细行）；不选择则不启用")], -1)), _createElementVNode("div", _hoisted_36, [_cache[9] || (_cache[9] = _createElementVNode("label", {
        class: "block text-xs font-medium text-slate-500 mb-1"
      }, "明细表", -1)), _createVNode(_component_el_select, {
        modelValue: detailKey.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => detailKey.value = $event),
        placeholder: "选择明细表（不选则不启用）",
        class: "form-select w-full",
        filterable: "",
        clearable: "",
        onChange: handleDetailKeyChange
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detailFieldCandidates.value, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item.key,
            label: item.label,
            value: item.key
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])]), detailKey.value ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createElementVNode("div", _hoisted_37, [_cache[10] || (_cache[10] = _createElementVNode("div", {
        class: "mb-2"
      }, [_createElementVNode("h4", {
        class: "text-sm font-semibold text-slate-700"
      }, "明细清单列（一明细行一行）"), _createElementVNode("p", {
        class: "text-xs text-slate-400 mt-0.5"
      }, "至少 1 列，顺序即导出列顺序；系统列每行继承所在实例的值")], -1)), _createElementVNode("div", _hoisted_38, [_createVNode(_component_el_select, {
        modelValue: pendingDetailColumnKey.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => pendingDetailColumnKey.value = $event),
        placeholder: "选择要添加的列",
        class: "form-select w-80",
        filterable: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_option_group, {
          label: "系统字段"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableDetailSystemColumns.value, item => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: 'sys-' + item.key,
              label: item.label,
              value: 'SYSTEM:' + item.key,
              disabled: item.added
            }, null, 8, ["label", "value", "disabled"]);
          }), 128))]),
          _: 1
        }), _createVNode(_component_el_option_group, {
          label: "明细子字段"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableDetailFieldColumns.value, item => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: 'field-' + item.key,
              label: item.label,
              value: 'FIELD:' + item.key,
              disabled: item.added
            }, null, 8, ["label", "value", "disabled"]);
          }), 128))]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"]), _createElementVNode("button", {
        type: "button",
        class: "btn-outline-primary",
        disabled: !pendingDetailColumnKey.value,
        onClick: addDetailColumn
      }, "添加列", 8, _hoisted_39)]), detailColumns.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_40, " 暂未配置明细清单列 ")) : (_openBlock(), _createElementBlock("div", _hoisted_41, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detailColumns.value, (col, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: col.type + ':' + col.key,
          class: _normalizeClass(["flex items-center gap-2 px-3 py-2 border rounded-lg", isDetailColumnInvalid(col) ? 'bg-amber-50 border-amber-300' : 'bg-white border-slate-200']),
          title: isDetailColumnInvalid(col) ? '引用的子字段已删除，保存时将被拦截' : ''
        }, [isDetailColumnInvalid(col) ? (_openBlock(), _createBlock(_component_el_icon, {
          key: 0,
          size: 12,
          class: "text-amber-500 shrink-0"
        }, {
          default: _withCtx(() => [_createVNode(_unref(WarningFilled))]),
          _: 1
        })) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_43, _toDisplayString(col.type === 'SYSTEM' ? '系统' : '字段'), 1), _createElementVNode("span", {
          class: "text-sm text-slate-600 w-44 truncate shrink-0",
          title: col.key
        }, _toDisplayString(sourceDetailColumnLabel(col)), 9, _hoisted_44), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": $event => col.label = $event,
          class: "form-input form-control-sm flex-1",
          placeholder: "列名（默认取字段名）"
        }, null, 8, _hoisted_45), [[_vModelText, col.label]]), _createElementVNode("div", _hoisted_46, [_createElementVNode("button", {
          type: "button",
          class: "w-6 h-6 flex items-center justify-center rounded bg-white border border-slate-300 hover:bg-slate-50 disabled:opacity-40",
          disabled: index === 0,
          onClick: $event => moveDetailColumn(index, -1)
        }, [_createVNode(_component_el_icon, {
          size: 10
        }, {
          default: _withCtx(() => [_createVNode(_unref(ArrowUp))]),
          _: 1
        })], 8, _hoisted_47), _createElementVNode("button", {
          type: "button",
          class: "w-6 h-6 flex items-center justify-center rounded bg-white border border-slate-300 hover:bg-slate-50 disabled:opacity-40",
          disabled: index === detailColumns.value.length - 1,
          onClick: $event => moveDetailColumn(index, 1)
        }, [_createVNode(_component_el_icon, {
          size: 10
        }, {
          default: _withCtx(() => [_createVNode(_unref(ArrowDown))]),
          _: 1
        })], 8, _hoisted_48), _createElementVNode("button", {
          type: "button",
          class: "w-6 h-6 flex items-center justify-center rounded bg-white border border-slate-300 hover:bg-red-50 hover:text-red-600",
          onClick: $event => removeDetailColumn(index)
        }, [_createVNode(_component_el_icon, {
          size: 10
        }, {
          default: _withCtx(() => [_createVNode(_unref(Delete))]),
          _: 1
        })], 8, _hoisted_49)])], 10, _hoisted_42);
      }), 128))]))]), _createElementVNode("div", _hoisted_50, [_createElementVNode("div", _hoisted_51, [_createElementVNode("h4", _hoisted_52, "明细汇总维度（" + _toDisplayString(_unref(STATS_DIMENSION_MIN)) + "-" + _toDisplayString(_unref(STATS_DIMENSION_MAX)) + " 个，顺序即分组层级）", 1), _cache[11] || (_cache[11] = _createElementVNode("p", {
        class: "text-xs text-slate-400 mt-0.5"
      }, "子字段维度仅支持下拉/单选/日期类型；系统维度继承所在实例的值；空值归入\"（空白）\"组", -1))]), _createElementVNode("div", _hoisted_53, [_createVNode(_component_el_select, {
        modelValue: pendingDetailDimensionKey.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => pendingDetailDimensionKey.value = $event),
        placeholder: "选择要添加的维度",
        class: "form-select w-80",
        filterable: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_option_group, {
          label: "系统维度"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableDetailSystemDimensions.value, item => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: 'sys-' + item.key,
              label: item.label,
              value: 'SYSTEM:' + item.key,
              disabled: item.added
            }, null, 8, ["label", "value", "disabled"]);
          }), 128))]),
          _: 1
        }), _createVNode(_component_el_option_group, {
          label: "明细子字段"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableDetailFieldDimensions.value, item => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: 'field-' + item.key,
              label: item.label,
              value: 'FIELD:' + item.key,
              disabled: item.added
            }, null, 8, ["label", "value", "disabled"]);
          }), 128))]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"]), _createElementVNode("button", {
        type: "button",
        class: "btn-outline-primary",
        disabled: !pendingDetailDimensionKey.value || detailDimensions.value.length >= _unref(STATS_DIMENSION_MAX),
        onClick: addDetailDimension
      }, "添加维度", 8, _hoisted_54)]), detailDimensions.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_55, " 暂未配置明细汇总维度 ")) : (_openBlock(), _createElementBlock("div", _hoisted_56, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detailDimensions.value, (dim, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: dim.type + ':' + dim.key,
          class: _normalizeClass(["flex items-center gap-2 px-3 py-2 border rounded-lg", isDetailDimensionInvalid(dim) ? 'bg-amber-50 border-amber-300' : 'bg-white border-slate-200']),
          title: isDetailDimensionInvalid(dim) ? '引用的子字段已删除或类型不再满足白名单，保存时将被拦截' : ''
        }, [isDetailDimensionInvalid(dim) ? (_openBlock(), _createBlock(_component_el_icon, {
          key: 0,
          size: 12,
          class: "text-amber-500 shrink-0"
        }, {
          default: _withCtx(() => [_createVNode(_unref(WarningFilled))]),
          _: 1
        })) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_58, "第 " + _toDisplayString(index + 1) + " 层", 1), _createElementVNode("span", {
          class: "text-sm text-slate-600 w-44 truncate shrink-0",
          title: dim.key
        }, _toDisplayString(sourceDetailDimensionLabel(dim)), 9, _hoisted_59), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": $event => dim.label = $event,
          class: "form-input form-control-sm flex-1",
          placeholder: "维度名（默认取字段名）"
        }, null, 8, _hoisted_60), [[_vModelText, dim.label]]), _createElementVNode("div", _hoisted_61, [_createElementVNode("button", {
          type: "button",
          class: "w-6 h-6 flex items-center justify-center rounded bg-white border border-slate-300 hover:bg-slate-50 disabled:opacity-40",
          disabled: index === 0,
          onClick: $event => moveDetailDimension(index, -1)
        }, [_createVNode(_component_el_icon, {
          size: 10
        }, {
          default: _withCtx(() => [_createVNode(_unref(ArrowUp))]),
          _: 1
        })], 8, _hoisted_62), _createElementVNode("button", {
          type: "button",
          class: "w-6 h-6 flex items-center justify-center rounded bg-white border border-slate-300 hover:bg-slate-50 disabled:opacity-40",
          disabled: index === detailDimensions.value.length - 1,
          onClick: $event => moveDetailDimension(index, 1)
        }, [_createVNode(_component_el_icon, {
          size: 10
        }, {
          default: _withCtx(() => [_createVNode(_unref(ArrowDown))]),
          _: 1
        })], 8, _hoisted_63), _createElementVNode("button", {
          type: "button",
          class: "w-6 h-6 flex items-center justify-center rounded bg-white border border-slate-300 hover:bg-red-50 hover:text-red-600",
          onClick: $event => removeDetailDimension(index)
        }, [_createVNode(_component_el_icon, {
          size: 10
        }, {
          default: _withCtx(() => [_createVNode(_unref(Delete))]),
          _: 1
        })], 8, _hoisted_64)])], 10, _hoisted_57);
      }), 128))]))]), _createElementVNode("div", null, [_cache[12] || (_cache[12] = _createElementVNode("div", {
        class: "mb-2"
      }, [_createElementVNode("h4", {
        class: "text-sm font-semibold text-slate-700"
      }, "明细汇总指标"), _createElementVNode("p", {
        class: "text-xs text-slate-400 mt-0.5"
      }, "至少 1 个；求和/平均/最大/最小限数值/金额子字段，计数固定统计明细行数")], -1)), _createElementVNode("div", _hoisted_65, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detailMetrics.value, (metric, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(["flex items-center gap-2 px-3 py-2 border rounded-lg", isDetailMetricInvalid(metric) ? 'bg-amber-50 border-amber-300' : 'bg-white border-slate-200']),
          title: isDetailMetricInvalid(metric) ? '引用的子字段已删除或不再是数值字段，保存时将被拦截' : ''
        }, [isDetailMetricInvalid(metric) ? (_openBlock(), _createBlock(_component_el_icon, {
          key: 0,
          size: 12,
          class: "text-amber-500 shrink-0"
        }, {
          default: _withCtx(() => [_createVNode(_unref(WarningFilled))]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_component_el_select, {
          modelValue: metric.key,
          "onUpdate:modelValue": $event => metric.key = $event,
          class: "form-select w-52",
          placeholder: "统计列",
          onChange: $event => onDetailMetricKeyChange(metric)
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detailMetricKeyCandidates.value, item => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: item.key,
              label: item.label,
              value: item.key
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue", "onUpdate:modelValue", "onChange"]), _createVNode(_component_el_select, {
          modelValue: metric.aggregate,
          "onUpdate:modelValue": $event => metric.aggregate = $event,
          class: "form-select w-32",
          disabled: metric.key === _unref(STATS_COUNT_KEY)
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(metric.key === _unref(STATS_COUNT_KEY) ? ['COUNT'] : ['SUM', 'AVG', 'MAX', 'MIN'], agg => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: agg,
              label: aggregateLabel(agg),
              value: agg
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 2
        }, 1032, ["modelValue", "onUpdate:modelValue", "disabled"]), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": $event => metric.label = $event,
          class: "form-input form-control-sm flex-1",
          placeholder: "指标名（默认取列名）"
        }, null, 8, _hoisted_67), [[_vModelText, metric.label]]), _createElementVNode("button", {
          type: "button",
          class: "w-6 h-6 flex items-center justify-center rounded bg-white border border-slate-300 hover:bg-red-50 hover:text-red-600 shrink-0",
          onClick: $event => removeDetailMetric(index)
        }, [_createVNode(_component_el_icon, {
          size: 10
        }, {
          default: _withCtx(() => [_createVNode(_unref(Delete))]),
          _: 1
        })], 8, _hoisted_68)], 10, _hoisted_66);
      }), 128)), detailMetrics.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_69, " 暂未配置明细汇总指标 ")) : _createCommentVNode("", true)]), _createElementVNode("button", {
        type: "button",
        class: "btn-outline-primary",
        onClick: addDetailMetric
      }, "添加指标")])], 64)) : _createCommentVNode("", true)]), hasInvalidKeys.value ? (_openBlock(), _createElementBlock("p", _hoisted_70, " 标黄项引用的字段已被删除或不再满足类型要求，保存时将被拦截，请调整后重试 ")) : _createCommentVNode("", true)])]);
    };
  }
};